const API_URL = "https://twitter-app-surazz501.herokuapp.com/api";

//const API_URL = "http://twitter.test/api";

export { API_URL };
